import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pasqua-pasqua-mylib',
  template: `
    <p>
      pasqua-mylib works!
    </p>
  `,
  styles: []
})
export class PasquaMylibComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
